// import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';

// const NewspaperLayout = ({ newsData, categoriesData }) => {
//     const [mainNews, setMainNews] = useState(null);
//     const [rightColumns, setRightColumns] = useState({ two: null, three: null });
//     const [imageStyles, setImageStyles] = useState({});
//     const [categoryStyles, setCategoryStyles] = useState({ line: '', category: '', button: '' });
//     const [categoryName, setCategoryName] = useState('');
//     const [id, setId] = useState('');
//     const [textColor, setTextColor] = useState('#000');

//     // useEffect(() => {
//     //     console.log("newsdata",newsData);
//     //     console.log("newsdata2",categoriesData);
//     //     const getLatestNewsByNumber = (numberValue) => {
//     //         const filteredNews = newsData
//     //             ?.filter(n => n.number === numberValue)
//     //             ?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
//     //         return filteredNews?.[0] || null;
//     //     };

//     //     const mainNews = getLatestNewsByNumber(1);
//     //     setMainNews(mainNews);

//     //     const newsWithNumberTwo = getLatestNewsByNumber(2);
//     //     const newsWithNumberThree = getLatestNewsByNumber(3);
//     //     setRightColumns({ two: newsWithNumberTwo, three: newsWithNumberThree });

//     //     const getCategoryColorAndName = (newsItem) => {
//     //         const category = categoriesData?.find(cat => cat.id === newsItem?.category_id);
//     //         return category ? { color: category.color, name: category.name } : { color: '#000', name: '' };
//     //     };

//     //     if (mainNews) {
//     //         const { color, name,id } = getCategoryColorAndName(mainNews);
//     //         setCategoryStyles({
//     //             line: color,
//     //             category: color,
//     //             button: color,
//     //         });
//     //         setCategoryName(name);
//     //         setId(id);

//     //         const isLightColor = (color) => {
//     //             const rgb = color.match(/\w\w/g).map(x => parseInt(x, 16));
//     //             const brightness = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
//     //             return brightness > 128;
//     //         };

//     //         setTextColor(isLightColor(color) ? '#000' : '#fff');
//     //     }

//     // }, [newsData, categoriesData]);

//     useEffect(() => {
//         if (!newsData || newsData.length === 0) return;
    
//         const getLatestByNumber = (numberValue) => {
//             const filtered = newsData
//                 .filter(news => news.number === numberValue)
//                 .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
//             return filtered[0] || null;
//         };
    
//         const first = getLatestByNumber(1);
//         const second = getLatestByNumber(2);
//         const third = getLatestByNumber(3);
    
//         setMainNews(first);
//         setRightColumns({
//             two: second,
//             three: third
//         });
    
//         const getCategoryColorAndName = (newsItem) => {
//             const category = categoriesData?.find(cat => cat.id === newsItem?.category_id);
//             return category ? { color: category.color, name: category.name, id: category.id } : { color: '#000', name: '', id: '' };
//         };
    
//         if (first) {
//             const { color, name, id } = getCategoryColorAndName(first);
//             setCategoryStyles({
//                 line: color,
//                 category: color,
//                 button: color,
//             });
//             setCategoryName(name);
//             setId(id);
    
//             const isLightColor = (color) => {
//                 const rgb = color.match(/\w\w/g).map(x => parseInt(x, 16));
//                 const brightness = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
//                 return brightness > 128;
//             };
    
//             setTextColor(isLightColor(color) ? '#000' : '#fff');
//         }
//     }, [newsData, categoriesData]);
    
    

//     const handleImageLoad = (event, id) => {
//         const img = event.target;
//         if (img.naturalWidth === img.naturalHeight) {
//             setImageStyles(prevStyles => ({
//                 ...prevStyles,
//                 [id]: { width: '70%', height: '70%' }
//             }));
//         }
//     };
    
//     const getFirstParagraphHtml = (html) => {
//         const tempDiv = document.createElement('div');
//         tempDiv.innerHTML = html;
//         const p = tempDiv.querySelector('p');
      
//         return p ? `<p>${p.textContent}</p>` : '';
//       };

//       const getFirstParagraphHtmlSecond = (html) => {
//         const tempDiv = document.createElement('div');
//         tempDiv.innerHTML = html;
//         const p = tempDiv.querySelector('p');
      
//         if (p) {
//           let text = p.textContent || '';
//           if (text.length > 100) {
//             text = text.substring(0, 100) + '...';
//           }
//           return `<p>${text}</p>`;
//         }
      
//         // Si no hay <p>, devolvemos texto plano recortado también
//         let text = tempDiv.textContent || '';
//         if (text.length > 100) {
//           text = text.substring(0, 100) + '...';
//         }
//         return `<p>${text}</p>`;
//       };
      
      
      
    

//     // const getFirstParagraph = (html) => {
//     //     const tempDiv = document.createElement('div');
//     //     tempDiv.innerHTML = html;

//     //     const firstParagraph = tempDiv.querySelector('p');

//     //     return firstParagraph ? firstParagraph.innerHTML : tempDiv.innerHTML;
//     // };

//     return (
//         <>
//             <div className='line_space'>
//                 <hr className='line' style={{ borderColor: categoryStyles.line }} />
//             </div>

//             <div className='news_category' style={{ backgroundColor: categoryStyles.category, color: textColor }}>
//                 {categoryName || 'Categoría'}
//             </div>

//             <div className="columns-container-principal">
//                 {mainNews && (
//                     <div className="main-news">
//                         <Link to={`/noticias/${mainNews.id}`}>
//                             <img
//                                 src={mainNews.image_url}
//                                 alt={mainNews.title}
//                                 style={imageStyles['main']}
//                                 onLoad={(e) => handleImageLoad(e, 'main')}
//                             />
//                             <h2>{mainNews.title}</h2>
//                             <div dangerouslySetInnerHTML={{ __html: getFirstParagraphHtml(mainNews.body) }} />


//                             <div className="columns-container">
//                                 <Link to={`/noticias/${mainNews.id}`} target='_blank'>
//                                     <div className='button_categorias' style={{ backgroundColor: categoryStyles.button, color: textColor }}>
//                                         Ver más
//                                     </div>
//                                 </Link>
//                             </div>
//                         </Link>
//                     </div>
//                 )}

//                 <div className="right-column">
//                     {rightColumns.two && (
//                         <div className="column-right">
//                             <Link to={`/noticias/${rightColumns.two.id}`}>
//                                 <img
//                                     src={rightColumns.two.image_url}
//                                     alt={`Noticia 2`}
//                                     style={imageStyles['two']}
//                                     onLoad={(e) => handleImageLoad(e, 'two')}
//                                 />
//                                 <h2>{rightColumns.two.title}</h2>
//                                 <div dangerouslySetInnerHTML={{ __html: getFirstParagraphHtmlSecond(rightColumns.two.body) }} />
//                                 <div className="columns-container">
//                                     <Link to={`/noticias/${rightColumns.two.id}`} target='_blank'>
//                                         <div className='button_categorias' style={{ backgroundColor: categoryStyles.button, color: textColor }}>
//                                             Ver más
//                                         </div>
//                                     </Link>
//                                 </div>
//                             </Link>
//                         </div>
//                     )}
//                     {rightColumns.three && (
//                         <div className="column-right">
//                             <Link to={`/noticias/${rightColumns.three.id}`}>
//                                 <img
//                                     src={rightColumns.three.image_url}
//                                     alt={`Noticia 3`}
//                                     style={imageStyles['three']}
//                                     onLoad={(e) => handleImageLoad(e, 'three')}
//                                 />
//                                 <h2>{rightColumns.three.title}</h2>
//                                 <div dangerouslySetInnerHTML={{ __html: getFirstParagraphHtmlSecond(rightColumns.two.body) }} />

//                                 <div className="columns-container">
//                                     <Link to={`/noticias/${rightColumns.three.id}`} target='_blank'>
//                                         <div className='button_categorias' style={{ backgroundColor: categoryStyles.button, color: textColor }}>
//                                             Ver más
//                                         </div>
//                                     </Link>
//                                 </div>
//                             </Link>
//                         </div>
//                     )}
//                 </div>
//             </div>
//             <h1>{categoriesData.id}</h1>
//             {/* <Link to={`/categorias/${id}`}>
//                 <div className='news_category' style={{ backgroundColor: categoryStyles.category, color: textColor }}>
//                     {categoryName || 'Categoría'}
//                     {id}
//                 </div>
//             </Link> */}
//         </>
//     );
// };

// export default NewspaperLayout;

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const NewspaperLayout = ({ newsData, categoriesData }) => {
  const [mainNews, setMainNews] = useState(null);
  const [rightColumns, setRightColumns] = useState({ two: null, three: null });
  const [imageStyles, setImageStyles] = useState({});
  const [categoryStyles, setCategoryStyles] = useState({ line: '', category: '', button: '' });
  const [categoryName, setCategoryName] = useState('');
  const [id, setId] = useState('');
  const [textColor, setTextColor] = useState('#000');

  useEffect(() => {
    if (!newsData || newsData.length === 0) return;

    const getLatestByNumber = (numberValue) => {
      const filtered = newsData
        .filter(news => news.number === numberValue)
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      return filtered[0] || null;
    };

    const first = getLatestByNumber(1);
    const second = getLatestByNumber(2);
    const third = getLatestByNumber(3);

    setMainNews(first);
    setRightColumns({ two: second, three: third });

    const getCategoryColorAndName = (newsItem) => {
      const category = categoriesData?.find(cat => cat.id === newsItem?.category_id);
      return category
        ? { color: category.color, name: category.name, id: category.id }
        : { color: '#000', name: '', id: '' };
    };

    if (first) {
      const { color, name, id } = getCategoryColorAndName(first);
      setCategoryStyles({
        line: color,
        category: color,
        button: color,
      });
      setCategoryName(name);
      setId(id);

      const isLightColor = (color) => {
        const rgb = color.match(/\w\w/g).map(x => parseInt(x, 16));
        const brightness = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return brightness > 128;
      };

      setTextColor(isLightColor(color) ? '#000' : '#fff');
    }
  }, [newsData, categoriesData]);

  const handleImageLoad = (event, id) => {
    const img = event.target;
    if (img.naturalWidth === img.naturalHeight) {
      setImageStyles(prevStyles => ({
        ...prevStyles,
        [id]: { width: '70%', height: '70%' }
      }));
    }
  };

  const getFirstParagraphHtml = (html) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const p = tempDiv.querySelector('p');
    return p ? `<p>${p.textContent}</p>` : '';
  };

  const getFirstParagraphHtmlSecond = (html) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const p = tempDiv.querySelector('p');

    if (p) {
      let text = p.textContent || '';
      if (text.length > 100) {
        text = text.substring(0, 100) + '...';
      }
      return `<p>${text}</p>`;
    }

    let text = tempDiv.textContent || '';
    if (text.length > 100) {
      text = text.substring(0, 100) + '...';
    }
    return `<p>${text}</p>`;
  };

  return (
    <>
      <div className='line_space'>
        <hr className='line' style={{ borderColor: categoryStyles.line }} />
      </div>

      <div className='news_category' style={{ backgroundColor: categoryStyles.category, color: textColor }}>
        {categoryName || 'Categoría'}
      </div>

      <div className="columns-container-principal">
        {mainNews && (
          <div className="main-news">
            <Link to={`/noticias/${mainNews.id}`}>
              <img
                src={mainNews.image_url}
                alt={mainNews.title}
                style={imageStyles['main']}
                onLoad={(e) => handleImageLoad(e, 'main')}
              />
              <h2>{mainNews.title}</h2>
              <div dangerouslySetInnerHTML={{ __html: getFirstParagraphHtml(mainNews.body) }} />

              <div className="columns-container">
                <Link to={`/noticias/${mainNews.id}`} target='_blank'>
                  <div className='button_categorias' style={{ backgroundColor: categoryStyles.button, color: textColor }}>
                    Ver más
                  </div>
                </Link>
              </div>
            </Link>
          </div>
        )}

        <div className="right-column">
          {rightColumns.two && (
            <div className="column-right">
              <Link to={`/noticias/${rightColumns.two.id}`}>
                <img
                  src={rightColumns.two.image_url}
                  alt={`Noticia 2`}
                  style={imageStyles['two']}
                  onLoad={(e) => handleImageLoad(e, 'two')}
                />
                <h2>{rightColumns.two.title}</h2>
                <div dangerouslySetInnerHTML={{ __html: getFirstParagraphHtmlSecond(rightColumns.two.body) }} />
                <div className="columns-container">
                  <Link to={`/noticias/${rightColumns.two.id}`} target='_blank'>
                    <div className='button_categorias' style={{ backgroundColor: categoryStyles.button, color: textColor }}>
                      Ver más
                    </div>
                  </Link>
                </div>
              </Link>
            </div>
          )}
          {rightColumns.three && (
            <div className="column-right">
              <Link to={`/noticias/${rightColumns.three.id}`}>
                <img
                  src={rightColumns.three.image_url}
                  alt={`Noticia 3`}
                  style={imageStyles['three']}
                  onLoad={(e) => handleImageLoad(e, 'three')}
                />
                <h2>{rightColumns.three.title}</h2>
                <div dangerouslySetInnerHTML={{ __html: getFirstParagraphHtmlSecond(rightColumns.three.body) }} />
                <div className="columns-container">
                  <Link to={`/noticias/${rightColumns.three.id}`} target='_blank'>
                    <div className='button_categorias' style={{ backgroundColor: categoryStyles.button, color: textColor }}>
                      Ver más
                    </div>
                  </Link>
                </div>
              </Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default NewspaperLayout;

